import {Component} from '@angular/core'
import {ToastrService} from 'ngx-toastr';
//import {MainAppComponent} from '../../../layout/layout.component';
@Component({
  selector: 'app-not-found',
  templateUrl: './notfound.html'
})

export class NotFoundComponent {

  constructor(
              private _toastrService: ToastrService) {

  }

  ngOnInit() {
  //  this._mApp.HideLoader();
  }
}
